import {
  getProductBySku,
  getProductData,
  getProducts,
  getPromotionProductsByHandle,
} from "../../api/productController";
import { getSearchSuggestions, getVendors } from "../../api/searchController";
import { noop } from "lodash";
import { getProductCategoriesAndTypes } from "../../api/staticDataController";

export const fetchProductsData = async ({
  productCategoryId,
  productTypeId,
  vendorId,
  makeId,
  modelId,
  variantId,
  yearId,
  pageNumber,
  limit,
  setProducts,
  setCategoryFilters = noop,
  setTypeFilters = noop,
  setVendorFilters = noop,
  setMakeFilters = noop,
  setModelFilters = noop,
  setVariantFilters = noop,
  setYearFilters = noop,
  setTotal,
  setPageSize,
  setStatusInProgress,
  setStatusSuccess,
  setStatusFailed,
  setStatusError,
}) => {
  setStatusInProgress();
  try {
    const processedProductCategory =
      productCategoryId === "all" ? null : productCategoryId;

    const response = await getProducts({
      productCategoryId: processedProductCategory,
      productTypeId,
      vendorId,
      makeId,
      modelId,
      variantId,
      yearId,
      pageNumber,
      limit,
    });

    if (!!response?.success) {
      const productsData = response.data.products.data;
      const total = response.data.products.total;
      const limit = response.data.products.limit;

      const categories = response.data.categories;
      const types = response.data.types;
      const vendors = response.data.vendors;
      const makes = response.data.makes;
      const models = response.data.models;
      const variants = response.data.variants;
      const years = response.data.years;

      setProducts(productsData);
      setTotal(total);
      setPageSize(limit);

      setCategoryFilters(categories ?? []);
      setTypeFilters(types ?? []);
      setVendorFilters(vendors ?? []);
      setMakeFilters(makes ?? []);
      setModelFilters(models ?? []);
      setVariantFilters(variants ?? []);
      setYearFilters(years ?? []);

      setStatusSuccess();
    } else {
      setStatusFailed();
    }
  } catch (error) {
    console.error(error);
    setStatusError();
  }
};

export const fetchPromotionProductsData = async ({
  handle,
  pageNumber,
  setPromotionProducts,
  setTotal,
  setPageSize,
  setStatusInProgress,
  setStatusSuccess,
  setStatusFailed,
  setStatusError,
}) => {
  setStatusInProgress();
  try {
    const response = await getPromotionProductsByHandle({
      handle,
      pageNumber,
    });

    if (!!response?.success) {
      const productsData = response.data.products.data;
      const total = response.data.products.total;
      const limit = response.data.products.limit;

      setPromotionProducts(productsData);
      setTotal(total);
      setPageSize(limit);
      setStatusSuccess();
    } else {
      setStatusFailed();
    }
  } catch (error) {
    console.error(error);
    setStatusError();
  }
};

export const fetchProductBySku = async ({
  productSku,
  setProductData,
  setStatusInProgress,
  setStatusSuccess,
  setStatusFailed,
  setStatusError,
}) => {
  setStatusInProgress();
  try {
    const response = await getProductBySku({ sku: productSku });
    if (response?.success) {
      setProductData(response.data);
      setStatusSuccess();
    } else {
      setStatusFailed();
    }
  } catch (error) {
    console.error(error);
    setStatusError();
  }
};

export const fetchProductsBySkus = async ({
  productSkus,
  setProductData,
  setStatusInProgress,
  setStatusSuccess,
  setStatusFailed,
  setStatusError,
}) => {
  setStatusInProgress();
  try {
    const response = await getProductData(productSkus);
    if (response.success) {
      if (response.data.length > 0) {
        setProductData(response.data);
      }
      setStatusSuccess();
    } else {
      setStatusFailed();
    }
  } catch (error) {
    console.error(error);
    setStatusError();
  }
};

export const fetchVendorsData = async ({
  setVendorData,
  setStatusInProgress,
  setStatusSuccess,
  setStatusFailed,
  setStatusError,
}) => {
  setStatusInProgress();
  try {
    const response = await getVendors();
    if (response.success) {
      setVendorData(response.data);
      setStatusSuccess();
    } else {
      setStatusFailed();
    }
  } catch (error) {
    console.error(error);
    setStatusError();
  }
};

export const fetchCategoriesAndTypes = async ({
  setCategoriesAndTypesData,
  setStatusInProgress,
  setStatusSuccess,
  setStatusFailed,
  setStatusError,
}) => {
  setStatusInProgress();
  try {
    const response = await getProductCategoriesAndTypes();
    if (response.success) {
      setCategoriesAndTypesData(response.data);
      setStatusSuccess();
    } else {
      setStatusFailed();
    }
  } catch (error) {
    console.error(error);
    setStatusError();
  }
};

export const fetchSearchSuggestions = async ({
  searchTerm,
  signal,
  setSearchResults,
  setStatusInProgress,
  setStatusSuccess,
  setStatusFailed,
  setStatusError,
}) => {
  setStatusInProgress();
  try {
    const response = await getSearchSuggestions(searchTerm, { signal });
    if (response?.canceled) {
      return;
    }
    if (response.success) {
      setSearchResults(response.data);
      setStatusSuccess();
    } else {
      setStatusFailed();
    }
  } catch (e) {
    console.error(e);
    setStatusError();
  }
};
